function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var GameScoreboardTemplate = require('./game-scoreboard.template');

/**
 *
 */
var GameScoreBoard = /*#__PURE__*/function () {
  /**
   *  @constructor
   *  @param app - Saito app
   *  @param game_mod - the game object
   */
  function GameScoreBoard(app, game_mod) {
    _classCallCheck(this, GameScoreBoard);
    this.app = app;
    this.game_mod = game_mod;
  }

  /**
   * Add scoreboard to screen
   */
  return _createClass(GameScoreBoard, [{
    key: "render",
    value: function render() {
      if (!this.game_mod.browser_active) {
        return;
      }
      if (!document.querySelector('#game-scoreboard')) {
        this.app.browser.addElementAfterSelector(GameScoreboardTemplate(), '#game-menu');
        this.attachEvents();
      }
    }

    /**
     * No functionality, display only component
     */
  }, {
    key: "attachEvents",
    value: function attachEvents() {}
  }, {
    key: "update",
    value: function update(html) {
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      console.log('********** update scoreboard **********');
      this.render();
      var scoreboard = document.querySelector('#game-scoreboard');
      if (scoreboard) {
        scoreboard.innerHTML = html;
        if (callback) {
          callback();
        }
      }
    }
  }, {
    key: "append",
    value: function append(html) {
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      this.render(this.app);
      var scoreboard = document.querySelector('#game-scoreboard');
      if (scoreboard) {
        scoreboard.innerHTML += html;
        if (callback) {
          callback();
        }
      }
    }
  }]);
}();
module.exports = GameScoreBoard;